
<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <div class="row pb-40">

      <!-- Status de l'emploi -->
      <div class="col-md-12 mb-5 text-center">
        <h5 class="mb-1">Status : </h5> <span class="badge badge-primary"
          *ngIf="jobEditing.getStatus() == 'En cours'">En cours d'édition</span> <span class="badge badge-warning"
          *ngIf="jobEditing.getStatus() == 'En attente de validation'">En attente de validation</span> <span
          class="badge badge-success" *ngIf="jobEditing.getStatus() == 'Validé'">Offre publiée</span>
      </div>

      <!-- Message -->
      <div class="col-md-12 mb-5 text-center">
        <strong style="color: red;">NB: </strong> Ajouter des notes croissante pour une même <strong>formation</strong> avec des diplômes de plus en plus supérieur.<br>
        <strong>Ex: Licence en Comptabilié : note(1); Master en Comptabilité: note (2).</strong>
      </div>

      <!-- Informations sur l'offre -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 65%;"> Informations sur l'offre </legend>
          <form [formGroup]="jobForm" (ngSubmit)="onSubmitJobForm()">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="reference">Référence</label>
                <input type="text" class="form-control" id="reference" [value]="reference" disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="areaActivity">Secteur d'activité <span class="star-style">**</span></label>
                <div class="input-group">
                  <select class="form-control" id="areaActivity" formControlName="area_activity_id">
                    <option value="">Selectionner...</option>
                    <option *ngFor="let areaActivity of areaActivityList" value="{{ areaActivity.getId() }}">{{
                      areaActivity.getLibelle() }}</option>
                  </select>
                  <div class="input-group-prepend" *ngIf="isAdmin">
                    <span class="input-group-text btn-prepend" (click)="addNewAreaActivity()">Nouv.</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <label for="profession">Profession <span class="star-style">**</span></label>
                <div class="input-group">
                  <select class="form-control" id="profession" formControlName="profession_id">
                    <option value="">Selectionner...</option>
                    <option *ngFor="let profession of professionList" value="{{ profession.getId() }}">{{
                      profession.getLibelle() }}</option>
                  </select>
                  <div class="input-group-prepend" *ngIf="isAdmin">
                    <span class="input-group-text btn-prepend" (click)="addNewProfession()">Nouv.</span>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label for="libelle">Libelle<span class="star-style">**</span></label>
                <input type="text" class="form-control h-40px" id="libelle" formControlName="libelle">
              </div>
              <div class="form-group col-md-6">
                <label for="typeJob">Type d'emploi<span class="star-style">**</span></label>
                <select class="form-control" id="typeJob" formControlName="type_job">
                  <option value="">Selectionner...</option>
                  <option value="Temps plein">Temps plein</option>
                  <option value="Temps partiel">Temps partiel</option>
                  <option value="Intérim">Intérim</option>
                  <option value="Stage">Stage</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="years_of_experience">Année d'exp. <span class="star-style">**</span></label>
                <select class="form-control" id="years_of_experience" formControlName="years_of_experience">
                  <option value="">Selectionner...</option>
                  <option value="Sans experience">Sans experience</option>
                  <option value="Moins d'un an">Moins d'un an</option>
                  <option value="1 à 2ans">1 à 2ans</option>
                  <option value="3 à 5ans">3 à 5ans</option>
                  <option value="6 à 10ans">6 à 10ans</option>
                  <option value="10 à 15ans">10 à 15ans</option>
                  <option value="Plus de 15ans">Plus de 15ans</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="maxAge">Age Maximum<span class="star-style">**</span></label>
                <input type="number" min="18" class="form-control h-40px" id="maxAge" formControlName="max_age">
              </div>
              <div class="form-group col-md-6">
                <label for="country">Pays<span class="star-style">**</span></label>
                <select class="form-control" id="country" formControlName="country"
                  (ngModelChange)="onChangeCountry($event)">
                  <option [value]="country" *ngFor="let country of countryList">{{ country }}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="city">Ville<span class="star-style">**</span></label>
                <select class="form-control" id="city" formControlName="city">
                  <option [value]="city" *ngFor="let city of cityList">{{ city }}</option>
                </select>
              </div>
            </div>

            <!-- Div block afficher/reduire -->
            <div id="infoBlock" style="display: none">
              <div class="row">
                <div class="form-group col-md-6" [ngClass]="jobDescribeValue == null ? 'form-group col-md-12' : 'form-group col-md-6'">
                  <label for="idcard">Description emploi<span style="font-size: 10px; font-weight: 700;">(pdf, < 1Mo)</span></label>
                  <span class="btn btn-success w-100" *ngIf="jobDescribeValue == null" (click)="chooseNewJobDescribeFile()">Joindre
                    fichier</span>
                  <span class="btn btn-success w-100" *ngIf="jobDescribeValue != null" (click)="chooseNewJobDescribeFile()">Remplacer
                    fichier</span>
                  <span *ngIf="jobDescribeFile != null" style="font-size: 10px; font-weight: 700; color: green"> Super! Fichier
                    joint</span>
                </div>
                <div class="form-group col-md-6 my-auto pt-3">
                  <a [href]="jobDescribe" target="_blank" class="btn btn-info w-100" *ngIf="jobDescribeValue !== undefined">Afficher description</a>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="expirationDate">Expire le, <span class="star-style">**</span></label>
                  <input type="date" class="form-control h-40px" id="expirationDate" formControlName="expiration_date">
                </div>
                <input type="hidden" class="form-control h-40px" formControlName="company_id">
                <div class="form-group col-md-6" *ngIf="isAdmin">
                  <label for="company">Société <span class="star-style">**</span></label>
                  <select class="form-control" id="company" formControlName="company_id">
                    <option value="">Selectionner...</option>
                    <option *ngFor="let company of companyList" value="{{ company.getId() }}">{{ company.getName() }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-12">
                  <label for="description">Description <span class="star-style">**</span></label>
                  <textarea class="form-control h-40px" id="description" row="4"
                    formControlName="description"></textarea>
                </div>
              </div>
              <span>
                <button type="submit" class="primary-btn text-white" [disabled]="jobForm.invalid"
                  *ngIf="!jobIsLoading">Enregister</button>
                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobIsLoading">Veuillez
                  patienter...</p>
              </span>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="infoLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('infoBlock', 'infoLabelToShowOrHide')">
              Afficher plus
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Diplômes & formations -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 50%;">Formations requises </legend>
          <form [formGroup]="jobTrainingForm" (ngSubmit)="onSubmitJobTrainingForm()">
            <div class="form-group">
              <label for="training">Formation requise <span class="star-style">**</span></label>
              <div class="input-group">
                <select class="form-control" id="training" formControlName="training_id">
                  <option value="">Selectionner...</option>
                  <option value="{{ training.getId() }}" *ngFor="let training of trainingList">{{ training.getLibelle()
                    }}</option>
                </select>
                <div class="input-group-prepend" *ngIf="isAdmin">
                  <span class="input-group-text btn-prepend" (click)="addNewTraining()">Nouv.</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="levelTraining">Niveau d'étude requis <span class="star-style">**</span></label>
              <select class="form-control" id="levelTraining" formControlName="level_of_study">
                <option value="">Selectionner...</option>
                <option value="Secondaire">Secondaire</option>
                <option value="Terminal">Terminal</option>
                <option value="Formation professionnelle">Formation professionnelle</option>
                <option value="Baccalauréat">Baccalauréat</option>
                <option value="Universitaire sans diplôme">Universitaire sans diplôme</option>
                <option value="BAC + 2">BAC + 2</option>
                <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
              </select>
            </div>
            <div class="form-group">
              <label for="rating_training">Note accordée</label>
              <input type="number" min="1" class="form-control h-40px" id="rating_training" formControlName="rating">
            </div>

            <span *ngIf="showAddButton">
              <button type="submit" class="primary-btn text-white" [disabled]="jobTrainingForm.invalid"
                *ngIf="!jobTrainingIsLoading">Ajouter</button>
              <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobTrainingIsLoading">Veuillez
                patienter...</p>
            </span>

            <!-- Div block afficher/reduire -->
            <div id="trainingBlock" style="display: none">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Formations</th>
                    <th>Niveau d'étude</th>
                    <th>Note</th>
                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let jobTraining of jobTrainingList">
                    <td>{{ jobTraining['trainings']['libelle'] }}</td>
                    <td>{{ jobTraining['levelOfStudy'] }}</td>
                    <td>{{ jobTraining['rating'] }}</td>
                    <td><span class="btn btn-danger" (click)="removeJobTraining(jobTraining['id'])">Supp</span></td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="trainingLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('trainingBlock', 'trainingLabelToShowOrHide')">
              Afficher plus
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Langues -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel min-h-340">
          <legend class="legend-style" style="width: 72%;">Connaissances lingustiques </legend>
          <form [formGroup]="jobLanguageForm" (ngSubmit)="onSubmitJobLanguageForm()">
            <div class="form-group">
              <label for="language">Langues <span class="star-style">**</span></label>
              <div class="input-group">
                <select class="form-control" id="language" formControlName="language_id">
                  <option value="">Selectionner...</option>
                  <option value="{{ language.getId() }}" *ngFor="let language of languageList">{{ language.getLibelle()
                    }}</option>
                </select>
                <div class="input-group-prepend" *ngIf="isAdmin">
                  <span class="input-group-text btn-prepend" (click)="addNewLanguage()">Nouv.</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="levelLanguage">Niveau de maitrise <span class="star-style">**</span></label>
              <select class="form-control" id="levelLanguage" formControlName="level">
                <option value="">Selectionner...</option>
                <option value="Débutant">Débutant</option>
                <option value="Intermédiaire">Intermédiaire</option>
                <option value="Excellente maitrise">Excellente maitrise</option>
              </select>
            </div>
            <div class="form-group">
              <label for="rating_langue">Note accordée</label>
              <input type="number" min="1" class="form-control h-40px" id="rating_langue" formControlName="rating">
            </div>
            <span *ngIf="showAddButton">
              <button type="submit" class="primary-btn text-white" [disabled]="jobLanguageForm.invalid"
                *ngIf="!jobLanguageIsLoading">Ajouter</button>
              <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobLanguageIsLoading">Veuillez
                patienter...</p>
            </span>

            <!-- Div block afficher/reduire -->
            <div id="languageBlock" style="display: none">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Langues</th>
                    <th>Niveau</th>
                    <th>Note</th>
                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let jobLanguage of jobLanguageList">
                    <td>{{ jobLanguage['languages']['libelle'] }}</td>
                    <td>{{ jobLanguage['level'] }}</td>
                    <td>{{ jobLanguage['rating'] }}</td>
                    <td><span class="btn btn-danger" (click)="removeJobLanguage(jobLanguage['id'])">Supp</span></td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="languageLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('languageBlock', 'languageLabelToShowOrHide')">
              Afficher plus
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Compétences -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel min-h-340">
          <legend class="legend-style" style="width: 72%;">Connaissances informatiques </legend>
          <form [formGroup]="jobSkillForm" (ngSubmit)="onSubmitJobSkillForm()">
            <div class="form-group">
              <label for="skill">Compétences <span class="star-style">**</span></label>
              <div class="input-group">
                <select class="form-control" id="skill" formControlName="skill_id">
                  <option value="">Selectionner...</option>
                  <option value="{{ skill.getId() }}" *ngFor="let skill of skillList">{{ skill.getLibelle() }}</option>
                </select>
                <div class="input-group-prepend" *ngIf="isAdmin">
                  <span class="input-group-text btn-prepend" (click)="addNewSkill()">Nouv.</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="skillLevel">Niveau de maitrise <span class="star-style">**</span></label>
              <select class="form-control" id="skillLevel" formControlName="level">
                <option value="">Selectionner...</option>
                <option value="Débutant">Débutant</option>
                <option value="Intermédiaire">Intermédiaire</option>
                <option value="Excellente maitrise">Excellente maitrise</option>
              </select>
            </div>
            <div class="form-group">
              <label for="rating_skill">Note accordée</label>
              <input type="number" min="1" class="form-control h-40px" id="rating_skill" formControlName="rating">
            </div>
            <span *ngIf="showAddButton">
              <button type="submit" class="primary-btn text-white" [disabled]="jobSkillForm.invalid"
                *ngIf="!jobSkillIsLoading">Ajouter</button>
              <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobSkillIsLoading">Veuillez
                patienter...</p>
            </span>

            <!-- Div block afficher/reduire -->
            <div id="skillBlock" style="display: none">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Logiciels</th>
                    <th>Niveau</th>
                    <th>Note</th>
                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let jobSkill of jobSkillList">
                    <td>{{ jobSkill['skills']['libelle'] }}</td>
                    <td>{{ jobSkill['level'] }}</td>
                    <td>{{ jobSkill['rating'] }}</td>
                    <td><span class="btn btn-danger" (click)="removeJobSkill(jobSkill['id'])">Supp</span></td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="skillLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('skillBlock', 'skillLabelToShowOrHide')">
              Afficher plus
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Button poster -->
      <div class="col-md-12 mb-3 text-center" *ngIf="showPublishButton">
        <button type="button" (click)="publishJob()" class="primary-btn btn-post-offer">Publier l'offre</button>
      </div>
    </div>
  </div>
</section>
<!-- End service Area -->